import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const cache = new Map<string, string>();

export const useMarkdownContent = (slug: string) => {
  const { i18n } = useTranslation();
  const [content, setContent] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lang = i18n.language;
    const key = `${lang}/${slug}`;

    if (cache.has(key)) {
      setContent(cache.get(key)!);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(`${process.env.PUBLIC_URL}/content/${lang}/${slug}.md`)
      .then((res) => {
        if (!res.ok) throw new Error('Not found');
        const contentType = res.headers.get('content-type') || '';
        if (contentType.includes('text/html')) throw new Error('Not markdown');
        return res.text();
      })
      .then((text) => {
        if (text.trimStart().startsWith('<!DOCTYPE') || text.trimStart().startsWith('<html')) {
          throw new Error('Not markdown');
        }
        cache.set(key, text);
        setContent(text);
      })
      .catch(() => {
        setContent(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [slug, i18n.language]);

  return { content, loading };
};
